import { editorWritableProperties, normalizeControlValue } from './model'

const own = (object, key) => Object.prototype.hasOwnProperty.call(object, key)
const cleanText = (value, max) => typeof value === 'string' && value.length <= max && !/[\u0000-\u001f\u007f]/.test(value)

/** 演示物模型只是本地输入规范，不是设备可写能力或服务端授权。 */
export function demoControlProperty (option = {}) {
  const input = option.demoProperty
  if (!input || typeof input !== 'object' || Array.isArray(input) || !cleanText(input.id, 128) || !input.id.trim()) throw new Error('请配置有效的演示属性标识')
  const valueType = {}
  for (const key of ['type', 'min', 'max', 'scale', 'maxLength', 'trueValue', 'falseValue', 'trueText', 'falseText', 'elements']) {
    if (own(input, key)) valueType[key] = input[key]
  }
  valueType.unit = cleanText(input.unit, 32) ? input.unit : ''
  const properties = editorWritableProperties({ properties: [{ id: input.id, name: cleanText(input.name, 128) && input.name ? input.name : input.id, expands: { source: 'device', type: ['write'] }, valueType }] })
  if (properties.length !== 1) throw new Error('演示属性类型暂不支持')
  return { ...properties[0], writable: input.writable === true }
}

export function demoControlObserved (property, input, timestamp = Date.now()) {
  if (input === undefined || input === null) return null
  // 校验只读示例值不等于授予交互权限；提交时仍使用原 writable。
  const value = normalizeControlValue({ ...property, writable: true }, input)
  const item = property.type === 'enum' && property.elements.find(item => Object.is(item.value, value))
  return { deviceId: 'demo', propertyId: property.id, timestamp, value, formatValue: item ? item.text : undefined, unit: property.unit || '', source: 'demo' }
}
